import React, { forwardRef, type Ref } from 'react';

import { IconButton } from '@atlaskit/button/new';

import { BadgeContainer } from '../../../components/badge-container';

import NotificationsIcon from './temp-icons/notifications';
import { type NotificationsProps } from './types';

const NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';

export const Notifications = forwardRef((props: NotificationsProps, ref: Ref<any>) => {
	const { badge, onClick, label, isSelected, ...iconButtonProps } = props;

	return (
		<BadgeContainer id={NOTIFICATIONS_BADGE_ID} badge={badge}>
			<IconButton
				icon={NotificationsIcon}
				label={label}
				onClick={onClick}
				appearance="subtle"
				isSelected={isSelected}
				ref={ref}
				{...iconButtonProps}
			/>
		</BadgeContainer>
	);
});

export default Notifications;
